<form class="container-fluid">
  <!-- ALL RESOURCE  === other versions -->
  <div class="checks row hello2">
    <div class="text-center col-6 col-md-3 toggle">
      <span title="Clear All" (click)="checkAll(false)" (keyup.enter)="checkAll(false)" tabindex="0"
        ><i class="fa fa-lg fa-square-o"></i>Clear All</span
      >
    </div>
    <div class="text-center col-6 col-md-3 toggle">
      <span title="Check All" (click)="checkAll(true)" (keyup.enter)="checkAll(true)" tabindex="0"
        ><i class="fa fa-lg fa-check-square-o"></i>Check All</span
      >
    </div>
    <div class="text-center col-6 col-md-3 toggle">
      <span title="Reset to Default" (click)="resetAll()" (keyup.enter)="resetAll()" tabindex="0"
        ><i class="fa fa-lg fa-retweet"></i>Set Default</span
      >
    </div>
    <div class="text-center col-6 col-md-3 toggle">
      <span
        title="{{ showCollapseAll ? 'Collapse All' : 'Expand All' }}"
        (keyup.enter)="toggleExpandCollapse()"
        (click)="toggleExpandCollapse()"
        tabindex="0"
      >
        <i [ngClass]="showCollapseAll ? 'fa fa-lg fa-compress' : 'fa fa-lg fa-expand'"></i>
        {{ showCollapseAll ? 'Collapse All' : 'Expand All' }}
      </span>
    </div>
  </div>

  <!-- Search Overlay -->
  <div class="row no-grid-comp" *ngIf="overlay">
    <div *ngFor="let item of resources; let i = index" class="width-100 compPadding">
      <div class="adv-header margin-5" style="padding-left: 0px">
        <input
          type="checkbox"
          tabindex="0"
          [id]="'overlay' + i + item.id"
          [attr.title]="item.id"
          [value]="item.id"
          [checked]="item.isDefault"
          [indeterminate]="item.checkedStatus === PARTIAL_CHECKED"
          (click)="checkGroup($event, item.searchTargets)"
        />
        <span class="custom-control-description font-0-8" [innerHTML]="item.heading"></span>
        <i
          aria-hidden="true"
          (click)="toggleGroup(item)"
          (keyup.enter)="toggleGroup(item)"
          tabindex="0"
          title="Show or Hide Resources"
          class="fa fa-sm"
          [ngClass]="{ 'fa-compress': !item.isCollapse, 'fa-expand': item.isCollapse }"
        >
        </i>
      </div>
      <div class="resources-main">
        <div
          *ngFor="let resource of item.searchTargets; let j = index"
          class="resource-ulist col-12 font-0-8"
          [ngClass]="{ 'display-none-class': item.isCollapse }"
        >
          <ng-container *ngIf="resource.targetType === 'WL'">
            <a
              class="resource-links"
              (click)="openUrl(resource.targetUrl)"
              (keyup.enter)="openUrl(resource.targetUrl)"
              tabindex="0"
            >
              <div
                [innerHTML]="resource.targetName"
                style="cursor: pointer; text-decoration: underline"
                class="d-inline-block"
              ></div
            ></a>
          </ng-container>
          <ng-container
            *ngIf="
              resource.targetType !== 'WL' &&
              (resource?.noteUrl === null || resource?.noteUrl === '')
            "
          >
            <label class="custom-checkbox">
              <input
                type="checkbox"
                tabindex="0"
                [value]="resource.libraryDBpoolKey"
                [attr.title]="resource.targetName"
                [checked]="resource.isDefault"
                (change)="checkResource($event, resource)"
              />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">
                <div
                  [innerHTML]="resource.targetName"
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                ></div>
                <i
                  *ngIf="resource.targetDescription"
                  class="resource-icon fa fa-comment-o"
                  aria-hidden="true"
                  [matTooltip]="resource.targetDescription"
                >
                </i>
              </span>
            </label>
          </ng-container>
          <ng-container
            *ngIf="
              resource.targetType !== 'WL' && resource?.noteUrl !== null && resource?.noteUrl !== ''
            "
          >
            <input
              type="checkbox"
              tabindex="0"
              [value]="resource.libraryDBpoolKey"
              [attr.title]="resource.targetName"
              [checked]="resource.isDefault"
              (change)="checkResource($event, resource)"
            />
            <!-- Does this need to be a label? -->
            <label for="resourceLinks" class="custom-checkbox">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">
                <a
                  class="resource-links-2"
                  (click)="openLink(resource?.noteUrl)"
                  (keyup.enter)="openUrl(resource.targetUrl)"
                  tabindex="0"
                >
                  <div
                    [innerHTML]="resource.targetName"
                    style="cursor: pointer; text-decoration: underline"
                    class="d-inline-block"
                  ></div>
                </a>
                <i
                  *ngIf="resource.targetDescription"
                  class="resource-icon fa fa-comment-o"
                  aria-hidden="true"
                  [matTooltip]="resource.targetDescription"
                >
                </i>
              </span>
            </label>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Header Side Nav -->
  <div class="row no-grid-comp" *ngIf="!overlay">
    <div
      *ngFor="let item of resources; let i = index"
      class="width-100"
      style="border-bottom: 1px solid var(--shade-three)"
    >
      <div class="adv-header margin-5-0">
        <label>
          <input
            type="checkbox"
            [id]="'head' + i + item.id"
            [value]="'head' + i + item.id"
            [checked]="item.isDefault"
            [indeterminate]="item.checkedStatus === PARTIAL_CHECKED"
            (click)="checkGroup($event, item.searchTargets)"
            (keyup.enter)="checkGroup($event, item.searchTargets)"
          />
          <span></span>
          <div
            [innerHTML]="item.heading"
            class="resource-group truncate-ellipsis"
            [title]="item.heading"
          ></div>
        </label>
        <i
          aria-hidden="true"
          (click)="toggleGroup(item)"
          (keyup.enter)="toggleGroup(item)"
          tabindex="0"
          title="Show or Hide Resources"
          class="fa fa-sm toggle-res"
          tabindex="0"
          [ngClass]="{ 'fa-compress': !item.isCollapse, 'fa-expand': item.isCollapse }"
        ></i>
      </div>
      <div class="resources-main">
        <div
          *ngFor="let resource of item?.searchTargets; let j = index"
          style="padding: 0px 5px"
          [ngClass]="{
            'resource-ulist col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4': true,
            'col-sm-6': item.numberOfTargets > 12,
            'col-lg-4': item.numberOfTargets > 24,
            'display-none-class': item.isCollapse
          }"
        >
          <ng-container *ngIf="resource.targetType === 'WL'">
            <a
              class="resource-links"
              (click)="openUrl(resource.targetUrl)"
              (keyup.enter)="openUrl(resource.targetUrl)"
              tabindex="0"
              ><div
                [innerHTML]="resource.targetName"
                style="cursor: pointer; text-decoration: underline"
                class="d-inline-block"
              ></div
            ></a>
          </ng-container>
          <ng-container
            *ngIf="
              resource?.targetType !== 'WL' &&
              (resource?.noteUrl === null || resource?.noteUrl === '')
            "
          >
            <label>
              <input
                type="checkbox"
                [id]="resource.libraryDBpoolKey"
                [value]="resource.libraryDBpoolKey"
                [attr.title]="resource.targetName"
                [checked]="resource.isDefault"
                (click)="checkResource($event, resource)"
                (keyup.enter)="checkResource($event, resource)"
              />
              <span>
                <div
                  [innerHTML]="resource.targetName"
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                ></div>
                <i
                  *ngIf="resource.targetDescription"
                  class="resource-icon fa fa-comment-o"
                  aria-hidden="true"
                  [matTooltip]="resource.targetDescription"
                >
                </i>
              </span>
            </label>
          </ng-container>
          <ng-container
            *ngIf="
              resource?.targetType !== 'WL' &&
              resource?.noteUrl !== null &&
              resource?.noteUrl !== ''
            "
          >
            <input
              type="checkbox"
              [id]="resource.libraryDBpoolKey"
              [value]="resource.libraryDBpoolKey"
              [attr.title]="resource.targetName"
              [checked]="resource.isDefault"
              (click)="checkResource($event, resource)"
              (keyup.enter)="checkResource($event, resource)"
            />
            <label for="resource-links-2">
              <a
                class="resource-links-2"
                id="resource-links-2"
                tabindex="0"
                (click)="openLink(resource?.noteUrl)"
                (keyup.enter)="openUrl(resource.targetUrl)"
              >
                <div
                  style="cursor: pointer; text-decoration: underline"
                  class="d-inline-block"
                  [innerHTML]="resource.targetName"
                ></div>
              </a>
              <i
                *ngIf="resource.targetDescription"
                class="resource-icon fa fa-comment-o"
                aria-hidden="true"
                [matTooltip]="resource.targetDescription"
              ></i>
            </label>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
